import { ChainSubtypeTabs } from 'modules/chains/components/ChainSubtypeTabs';
import { ChainTypeTabs } from 'modules/chains/components/ChainTypeTabs';
import { GroupSelect } from 'modules/chains/components/GroupSelect';
import { useChainSelectors } from 'modules/chains/components/ChainSelectorsProvider';

import { useChainSelectorsStyles } from './useChainSelectorsStyles';

export const ChainSelectors = () => {
  const { classes } = useChainSelectorsStyles();

  const { groups } = useChainSelectors();

  return (
    <div className={classes.root}>
      <ChainTypeTabs
        className={classes.tabs}
        classNameTab={classes.tab}
        classNameTabsInner={classes.tabsInner}
        classNameTabsWrapper={classes.tabsWrapper}
      />
      <ChainSubtypeTabs
        className={classes.tabs}
        classNameTab={classes.tab}
        classNameTabsInner={classes.tabsInner}
        classNameTabsWrapper={classes.tabsWrapper}
      />
      <GroupSelect
        classes={{
          select: classes.groupSelectSelect,
          input: classes.groupSelectInput,
        }}
        disableGroupsWithoutNetwork
        visible={groups.length > 1}
      />
    </div>
  );
};
